import Comment from '@opsbase/lib-conversation/Comment';
import ActivityType from '@opsbase/lib-issue/ActivityType';
import Palette from '@opsbase/lib-palette/Palette';
import IssueActivity from '@opsbase/web-conversation-views/src/IssueActivity';
import MessageView from '@opsbase/web-conversation-views/src/MessageView';
import useCss from '@opsbase/web-css';
import Pane from '@opsbase/web-layout/Pane';
import Vertical from '@opsbase/web-layout/Vertical';
import moment from 'moment';
import momentTimeZone from 'moment-timezone';
import React, { useMemo } from 'react';
const makeMyClasses = () => ({
    root: {
        maxHeight: '100%',
        flexWrap: 'nowrap',
        border: `1px solid ${Palette.InputBorderGrey.main}`,
        backgroundColor: 'white',
        borderRadius: 8,
        overflow: 'hidden',
    },
    comments: {
        flex: 1,
        width: '100%',
        overflow: 'auto',
    },
    commentPane: {
        borderTop: `1px solid ${Palette.InputBorderGrey.main}`,
        boxShadow: `-4px 0 12px -4px ${Palette.LavendarGrey.main}`,
    },
});
const isComment = (item) => 'commentDate' in item;
const getKey = (item) => {
    const date = !isComment(item) ? item.activityDate : item.commentDate;
    const id = !isComment(item) ? item.staffId : item.id;
    return `${id}_${momentTimeZone(date)}`;
};
export function DetailsReportConversation({ conversation, activity, timezone }) {
    const myCss = useCss(makeMyClasses);
    const timelineData = useMemo(() => {
        var _a, _b;
        const filteredComments = (_b = (_a = conversation.messages) === null || _a === void 0 ? void 0 : _a.filter(z => z)) !== null && _b !== void 0 ? _b : [];
        const filteredTimeline = (activity !== null && activity !== void 0 ? activity : []).filter(z => z.type !== ActivityType.ADD_COMMENT &&
            z.type !== ActivityType.EDIT_COMMENT &&
            z.type !== ActivityType.DELETE_COMMENT);
        const timeline = [...filteredComments, ...filteredTimeline].sort((a, b) => {
            var _a, _b;
            const aMomentDate = moment(((_a = a.commentDate) !== null && _a !== void 0 ? _a : a.activityDate));
            const bMomentDate = moment(((_b = b.commentDate) !== null && _b !== void 0 ? _b : b.activityDate));
            return aMomentDate.isAfter(bMomentDate) ? 1 : aMomentDate.isBefore(bMomentDate) ? -1 : 0;
        });
        return timeline === null || timeline === void 0 ? void 0 : timeline.map((timelineItem, idx) => {
            var _a, _b;
            const staff = (_a = conversation.participants) === null || _a === void 0 ? void 0 : _a.find(c => c.id === timelineItem.staffId);
            const currentKey = getKey(timelineItem);
            const nextKey = timeline.length > idx + 1 ? getKey(timeline[idx + 1]) : null;
            const prevKey = idx > 0 ? getKey(timeline[idx - 1]) : null;
            const firstItem = prevKey !== currentKey;
            const lastItem = currentKey !== nextKey;
            const data = {
                staff,
                isSelf: false,
                firstItem,
                lastItem,
            };
            if (timelineItem.commentDate) {
                const comment = new Comment(timelineItem);
                const commentIndex = (_b = conversation.messages) === null || _b === void 0 ? void 0 : _b.findIndex(z => z.title === comment.title && z.photos === comment.photos);
                return {
                    ...data,
                    comment,
                    editing: false,
                    commentIndex,
                };
            }
            else {
                return {
                    ...data,
                    activity: timelineItem,
                };
            }
        });
    }, [activity, conversation]);
    const timelineViews = useMemo(() => timelineData === null || timelineData === void 0 ? void 0 : timelineData.map((timelineItem, idx) => {
        if (timelineItem.comment) {
            const { comment, staff, commentIndex, editing, isSelf, firstItem, lastItem } = timelineItem;
            return (React.createElement(MessageView, { key: idx, comment: comment, commentor: staff, editable: false, commentIndex: commentIndex, editing: editing, isSelf: isSelf, firstItem: firstItem, lastItem: lastItem, timezone: timezone }));
        }
        else {
            const { activity: tActivity, staff, isSelf, firstItem, lastItem, } = timelineItem;
            return (React.createElement(IssueActivity, { key: idx, activity: tActivity, commentor: staff, isSelf: isSelf, firstItem: firstItem, lastItem: lastItem, timezone: timezone }));
        }
    }), [timelineData, timezone]);
    return (React.createElement(Vertical, { classes: { root: myCss.root } },
        React.createElement(Pane, { classes: { root: myCss.comments } }, timelineViews)));
}
export default DetailsReportConversation;
